module.exports = __webpack_public_path__ + "static/img/方太蒸烤炸炖一体机 EP1.21a6c53d.png";